<template>
	<svg class="Icon" :class="iconClasses" alt="" aria-hidden="true">
		<use :xlink:href="'#Icon--' + symbol" />
	</svg>
</template>

<script>
import '@/icons/svg/Icon--access.svg';
import '@/icons/svg/Icon--addArea.svg';
import '@/icons/svg/Icon--animal.svg';
import '@/icons/svg/Icon--arrowDown.svg';
import '@/icons/svg/Icon--arrowLeft.svg';
import '@/icons/svg/Icon--arrowRight.svg';
import '@/icons/svg/Icon--arrowUp.svg';
import '@/icons/svg/Icon--audio.svg';
import '@/icons/svg/Icon--audioMedium.svg';
import '@/icons/svg/Icon--audioMissing.svg';
import '@/icons/svg/Icon--audioMute.svg';
import '@/icons/svg/Icon--badgePhotographed.svg';
import '@/icons/svg/Icon--badgeRecordedAudio.svg';
import '@/icons/svg/Icon--badgeSeen.svg';
import '@/icons/svg/Icon--badgeSeenYear.svg';
import '@/icons/svg/Icon--barchart.svg';
import '@/icons/svg/Icon--bins.svg';
import '@/icons/svg/Icon--cart.svg';
import '@/icons/svg/Icon--chart.svg';
import '@/icons/svg/Icon--check.svg';
import '@/icons/svg/Icon--checklist.svg';
import '@/icons/svg/Icon--close.svg';
import '@/icons/svg/Icon--comment.svg';
import '@/icons/svg/Icon--commentAdd.svg';
import '@/icons/svg/Icon--contact.svg';
import '@/icons/svg/Icon--date.svg';
import '@/icons/svg/Icon--delete.svg';
import '@/icons/svg/Icon--directionDown.svg';
import '@/icons/svg/Icon--directionUp.svg';
import '@/icons/svg/Icon--directions.svg';
import '@/icons/svg/Icon--download.svg';
import '@/icons/svg/Icon--edit.svg';
import '@/icons/svg/Icon--embed.svg';
import '@/icons/svg/Icon--exoticEscapee.svg';
import '@/icons/svg/Icon--exoticNaturalized.svg';
import '@/icons/svg/Icon--exoticProvisional.svg';
import '@/icons/svg/Icon--figure.svg';
import '@/icons/svg/Icon--filter.svg';
import '@/icons/svg/Icon--flag.svg';
import '@/icons/svg/Icon--fullscreen.svg';
import '@/icons/svg/Icon--fullscreenCancel.svg';
import '@/icons/svg/Icon--gallery.svg';
import '@/icons/svg/Icon--gift.svg';
import '@/icons/svg/Icon--grid.svg';
import '@/icons/svg/Icon--help.svg';
import '@/icons/svg/Icon--hidden.svg';
import '@/icons/svg/Icon--info.svg';
import '@/icons/svg/Icon--jumpBack.svg';
import '@/icons/svg/Icon--jumpDown.svg';
import '@/icons/svg/Icon--language.svg';
import '@/icons/svg/Icon--link.svg';
import '@/icons/svg/Icon--list.svg';
import '@/icons/svg/Icon--locationGeneric.svg';
import '@/icons/svg/Icon--locationGenericMarker.svg';
import '@/icons/svg/Icon--locationHotspot.svg';
import '@/icons/svg/Icon--locationHotspotCircle.svg';
import '@/icons/svg/Icon--locationHotspotMarker.svg';
import '@/icons/svg/Icon--locationPersonal.svg';
import '@/icons/svg/Icon--locationPersonalMarker.svg';
import '@/icons/svg/Icon--lockClosed.svg';
import '@/icons/svg/Icon--lockOpen.svg';
import '@/icons/svg/Icon--map.svg';
import '@/icons/svg/Icon--mapAndroidMyLocation.svg';
import '@/icons/svg/Icon--mapIOSMyLocation.svg';
import '@/icons/svg/Icon--mapLayers.svg';
import '@/icons/svg/Icon--media.svg';
import '@/icons/svg/Icon--menu.svg';
import '@/icons/svg/Icon--microphone.svg';
import '@/icons/svg/Icon--minus.svg';
import '@/icons/svg/Icon--more.svg';
import '@/icons/svg/Icon--newTab.svg';
import '@/icons/svg/Icon--nocturnal.svg';
import '@/icons/svg/Icon--pause.svg';
import '@/icons/svg/Icon--photo.svg';
import '@/icons/svg/Icon--photoMissing.svg';
import '@/icons/svg/Icon--play.svg';
import '@/icons/svg/Icon--plus.svg';
import '@/icons/svg/Icon--portal.svg';
import '@/icons/svg/Icon--print.svg';
import '@/icons/svg/Icon--rare.svg';
import '@/icons/svg/Icon--record.svg';
import '@/icons/svg/Icon--refresh.svg';
import '@/icons/svg/Icon--region.svg';
import '@/icons/svg/Icon--retry.svg';
import '@/icons/svg/Icon--review.svg';
import '@/icons/svg/Icon--search.svg';
import '@/icons/svg/Icon--settings.svg';
import '@/icons/svg/Icon--shuffle.svg';
import '@/icons/svg/Icon--socialFacebook.svg';
import '@/icons/svg/Icon--socialInstagram.svg';
import '@/icons/svg/Icon--socialShare.svg';
import '@/icons/svg/Icon--socialTwitter.svg';
import '@/icons/svg/Icon--sort.svg';
import '@/icons/svg/Icon--species.svg';
import '@/icons/svg/Icon--spinner.svg';
import '@/icons/svg/Icon--star.svg';
import '@/icons/svg/Icon--tags.svg';
import '@/icons/svg/Icon--taxonomy.svg';
import '@/icons/svg/Icon--timer.svg';
import '@/icons/svg/Icon--track.svg';
import '@/icons/svg/Icon--trackEnd.svg';
import '@/icons/svg/Icon--trackStart.svg';
import '@/icons/svg/Icon--triangleDown.svg';
import '@/icons/svg/Icon--triangleRight.svg';
import '@/icons/svg/Icon--uncertain.svg';
import '@/icons/svg/Icon--uncommon.svg';
import '@/icons/svg/Icon--user.svg';
import '@/icons/svg/Icon--userCircle.svg';
import '@/icons/svg/Icon--users.svg';
import '@/icons/svg/Icon--video.svg';
import '@/icons/svg/Icon--warning.svg';

export default {
	name: 'CloIcon',
	data() {
		return {};
	},
	props: {
		symbol: {
			required: true,
			type: String,
		},
		size: {
			type: String,
			default: '',
		},
		classes: {
			type: String,
			default: '',
		},
	},
	computed: {
		iconClasses: function () {
			let classes = ['Icon--' + this.symbol];
			if (this.size.length) {
				classes.push('Icon--' + this.size);
			}
			if (this.classes.length) {
				classes.push(this.classes);
			}
			return classes.join(' ');
		},
	},
};
</script>

<style lang="scss">
// Size mixins
@mixin iconSize($size) {
	width: $size;
	height: $size;
}
/* Small - 16px, matches text 4 */
@mixin icon-sm {
	@include iconSize(1rem);
}
/* Medium (default) - 24px, matches text 6 */
@mixin icon-md {
	@include iconSize(1.5rem);
}
/* Large - 32px, closest match is text 7 */
@mixin icon-lg {
	@include iconSize(2rem);
}

// Base style
.Icon {
	@include icon-md;
	// inherit the color of the parent element
	fill: currentColor;
	// if set next to inline text, this should align the icon with the text
	vertical-align: middle;
	// http://stackoverflow.com/questions/24078524/svg-click-events-not-firing-bubbling-when-using-use-element
	pointer-events: none;
}

/* ----------------
	Size mixins and variants
---------------- */

/* Small - 16px, matches text 4 */
.Icon--sm {
	@include icon-sm;
}

/* Medium (default) - 24px, matches text 6 */
.Icon--md {
	@include icon-md;
}

/* Large - 32px, closest match is text 7 */
.Icon--lg {
	@include icon-lg;
}

/* ----------------
	Icon variants
---------------- */

// Orange icons
.Icon--review,
.Icon--uncommon,
.Icon--colorAlert {
	fill: $color-alert-3;
}

// Red icons
.Icon--rare {
	fill: $color-alert-3;
}

// Blue icons
.Icon--trackEnd,
.Icon--trackStart {
	fill: $color-primary-3;
}

/* Icons with directionality that should flip for RTL languages */
[dir='rtl'] {
	.Icon--arrowLeft,
	.Icon--arrowRight,
	.Icon--newTab,
	.Icon--addArea,
	.Icon--audio,
	.Icon--badgeRecordedAudio,
	.Icon--species,
	.Icon--jumpBack,
	.Icon--jumpDown,
	.Icon--list,
	.Icon--photoMissing,
	.Icon--audioMissing,
	.Icon--audioMute,
	.Icon--sort,
	.Icon--species,
	.Icon--socialShare,
	.Icon--taxonomy,
	.Icon--triangleRight,
	.Icon--retry,
	.Icon--video,
	.Icon--audioMedium {
		transform: scaleX(-1);
	}
	.MediaControls-controls {
		.Icon--arrowLeft,
		.Icon--arrowRight {
			transform: scaleX(1);
		}
	}
}
</style>
